// extracted by mini-css-extract-plugin
export default {"register_content":"Register_register_content__Wc3-w","register_green":"Register_register_green__L2ZBO","register_polici_container":"Register_register_polici_container__XkNvM"};